// extracted by mini-css-extract-plugin
export default {"main":"_69057584ae","tit":"a987fcc9fe","maintitle":"b959a193a6","ylw":"_62899725c0","white":"_5a2cd33b61","mv_title":"_484dbbc6e9","mv_nc":"_30797b7a70","mv_in":"_73b54134a3"};